export default "__VITE_ASSET__CcrWO7mz__"